/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useState, useRef } from "react";
import validator from "email-validator";
import {
  BorderContainer,
  Container,
  Close,
  Button,
  Subtitle,
  MainTitle,
  DivWithAccess,
  Access,
  PopupMessage,
} from "../mainStyles";
import { socket } from "../../../REST/api";
import { useSelector } from "react-redux";

import styled from "styled-components";

const PopupCEmail = styled(PopupMessage)`
  right: 5rem;
  bottom: 4rem;
`;
const PopupCNews = styled(PopupMessage)`
  right: 5rem;
  bottom: 2rem;
`;

const Collaborate = ({ togglePopup }) => {
  const { accessToken: token } = useSelector(state =>
    state.updateAuthReducer.get("authData")
  );
  const [spinner, setspinner] = useState(false);
  const [sent, setSent] = useState(false);

  const [errorEmail, seterrorEmail] = useState(false);
  const [mailArr, setmailArr] = useState([]);

  const removeTag = i => {
    const newTags = [...mailArr];
    newTags.splice(i, 1);
    setmailArr(newTags);
  };

  var tagInput = useRef();

  const inputKeyDown = e => {
    const val = e.target.value;
    if (e.key === "Enter" && val) {
      if (mailArr.find(tag => tag.toLowerCase() === val.toLowerCase())) {
        return;
      }
      if (validator.validate(val)) {
        setmailArr([...mailArr, val]);
        tagInput.value = null;
      }
    } else if (e.key === "Backspace" && !val) {
      removeTag(mailArr.length - 1);
    }
  };

  const _sendPdf = e => {
    e.preventDefault();
    setspinner(true);

    setSent(false);
    seterrorEmail(false);

    const arr =
      mailArr.length === 0
        ? validator.validate(tagInput.value)
          ? tagInput.value
          : null
        : mailArr;

    if (arr) {
      console.log("sendInvitation");
      console.log(arr)
      socket.emit(
        "sendInvitation",
        {
          canvasId: localStorage.getItem("id"),
          url: window.location.href,
          token,
          emails: [arr]
        },
        data => {
          console.log(data);
          setTimeout(() => {
            setspinner(false);
            if (data.status === 200) {
              setSent(true);
              seterrorEmail(false);
            } else {
              setSent(false);
              seterrorEmail(true);
            }
          }, 100);
        }
      );
    } else {
      setspinner(false);

      seterrorEmail(true);
    }
  };

  return (
    <BorderContainer onClick={togglePopup} id="collaborate">
      <Container style={{ height: "33rem" }} id="containercollaborate">
        <Close id={"collaborate"}>&times;</Close>
        <MainTitle>Share Lean Canvas</MainTitle>
        <Subtitle style={{ marginBottom: "2rem" }}>
          Consult your friends or colleagues. Send the invites by typing their
          emails below.
        </Subtitle>
        <DivWithAccess>
          <div
            style={{ display: "flex", flexDirection: "column", width: "55%" }}
          >
            <Access>Send by email</Access>
            <div className="input-tag">
              <ul className="input-tag__tags">
                {mailArr.map((tag, i) => (
                  <li key={tag}>
                    {tag}
                    <button
                      type="button"
                      onClick={() => {
                        removeTag(i);
                      }}
                    >
                      &times;
                    </button>
                  </li>
                ))}
                <li className="input-tag__tags__input">
                  <input
                    type="text"
                    onKeyDown={inputKeyDown}
                    ref={c => {
                      tagInput = c;
                    }}
                  />
                </li>
              </ul>
            </div>
          </div>

          <Button onClick={e => _sendPdf(e)}>
            {spinner ? <div className="spinner" /> : `Send`}
          </Button>
          {sent && <PopupCNews>Invites Sent! 🎉</PopupCNews>}
          {errorEmail && <PopupCEmail>Please check emails</PopupCEmail>}
        </DivWithAccess>
      </Container>
    </BorderContainer>
  );
};

export default Collaborate;
